import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import {
  GetIntegrationSettingsResponseTO,
  IntegrationSettings,
} from 'models/Integrations';
import API from 'services/API';

export const INTEGRATION_SETTINGS_BASE_QUERY_KEY = 'integration-settings';

type ReactQueryOptions = Omit<
  UseQueryOptions<IntegrationSettings[]>,
  'queryKey' | 'queryFn'
>;

type UseFetchPropertyIntegrationSettingsArgs = {
  propertyUid: string;
} & ReactQueryOptions;

const useFetchPropertyIntegrationSettings = ({
  propertyUid,
  enabled = true,
  ...options
}: UseFetchPropertyIntegrationSettingsArgs) => {
  return useAppQuery<IntegrationSettings[]>({
    queryKey: [INTEGRATION_SETTINGS_BASE_QUERY_KEY, 'detail', propertyUid],
    queryFn: async () => {
      const response = await API.get<GetIntegrationSettingsResponseTO>(
        `/v3/integrations-settings?propertyUid=${propertyUid}`,
      );

      return response.data.integrationSettings;
    },
    enabled,
    ...options,
  });
};

export default useFetchPropertyIntegrationSettings;
